import React, { useEffect, useState } from 'react';
import { store, setStore } from '../../../app/store';
import { postAPI } from '../../../app/api'
import CustomImage from '../../../UIComponents/CustomImage'
import { useParams, useNavigate } from 'react-router-dom';
import ReactApexChart from "react-apexcharts";
import Wrapper from '../Universal/Wrapper'
const { REACT_APP_BRANDURL } = process.env;

export default function MainDashboard() {
  const navigate = useNavigate();
  const [is_loader, setIsLoader] = useState(false)
  const [dashboardData, setDashboardData] = useState({
    stats: {
      totalMembers: 0,
      pendingMembers: 0,
      newMembersThisYear: 0,
      totalAmountReceived: '0.00',
      dateRange: ''
    },
    chartData: [],
    recentTransactions: []
  });

  useEffect(() => {
    fetchDashboardData();
  }, []);

  const fetchDashboardData = async () => {
    console.log('Fetching dashboard data...');
    setIsLoader(true);
    try {
      const response = await postAPI("/dashboard/stats", {});
      console.log('Dashboard API response:', response);
      if (response?.status === 1) {
        setDashboardData(response.data);
        console.log('Dashboard data set:', response.data);
      } else {
        console.error('API returned error status:', response);
        // Set default data on error
        setDashboardData({
          stats: {
            totalMembers: 0,
            pendingMembers: 0,
            newMembersThisYear: 0,
            totalAmountReceived: '0.00'
          },
          chartData: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          recentTransactions: []
        });
      }
    } catch (error) {
      console.error('Error fetching dashboard data:', error);
      // Set default data on error
      setDashboardData({
        stats: {
          totalMembers: 0,
          pendingMembers: 0,
          newMembersThisYear: 0,
          totalAmountReceived: '0.00'
        },
        chartData: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        recentTransactions: []
      });
    } finally {
      setIsLoader(false);
    }
  };

  const [state, setState] = useState({
    series: [
      {
        name: "New Members",
        data: [],
      },
    ],
    options: {
      chart: {
        height: 350,
        type: "bar",
      },
      plotOptions: {
        bar: {
          borderRadius: 10,
          dataLabels: {
            position: "top",
          },
        },
      },
      dataLabels: {
        enabled: true,
        formatter: function (val) {
          return val;
        },
        offsetY: -20,
        style: {
          fontSize: "12px",
          colors: ["#304758"],
        },
      },
      xaxis: {
        categories: [
          "Jan", "Feb", "Mar", "Apr", "May", "Jun",
          "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
        ],
        position: "top",
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
        crosshairs: {
          fill: {
            type: "gradient",
            gradient: {
              colorFrom: "#D8E3F0",
              colorTo: "#BED1E6",
              stops: [0, 100],
              opacityFrom: 0.4,
              opacityTo: 0.5,
            },
          },
        },
        tooltip: {
          enabled: true,
        },
      },
      yaxis: {
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
        labels: {
          show: false,
          formatter: function (val) {
            return val;
          },
        },
      },
      title: {
        text: "Monthly New Members Registration",
        floating: true,
        offsetY: 330,
        align: "center",
        style: {
          color: "#444",
        },
      },
    },
  });

  // Update chart data when dashboard data changes
  useEffect(() => {
    if (dashboardData.chartData.length > 0) {
      setState(prevState => ({
        ...prevState,
        series: [
          {
            name: "New Members",
            data: dashboardData.chartData,
          },
        ]
      }));
    }
  }, [dashboardData]);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-IN', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    });
  };

  const formatCurrency = (amount) => {
    return `₹ ${parseFloat(amount).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  };
  return (
    <>
      <Wrapper is_loader={is_loader}>
        <div className="row">
          <div className="col-md-3 stretch-card grid-margin">
            <div className="card bg-gradient-danger card-img-holder text-white">
              <div className="card-body">
                <h4 className="font-weight-normal mb-2">Total Members</h4>
                <h2 className="mb-4 text-white">{dashboardData.stats.totalMembers}</h2>
              </div>
            </div>
          </div>
          <div className="col-md-3 stretch-card grid-margin">
            <div className="card bg-gradient-info card-img-holder text-white">
              <div className="card-body">
                <h4 className="font-weight-normal mb-2">Pending Members</h4>
                <h2 className="mb-4 text-white">{dashboardData.stats.pendingMembers}</h2>
              </div>
            </div>
          </div>
          <div className="col-md-3 stretch-card grid-margin">
            <div className="card bg-gradient-secondary card-img-holder text-white">
              <div className="card-body">
                <h4 className="font-weight-normal mb-2">YTD Total Amount Received</h4>
                <h2 className="mb-4 text-white">{formatCurrency(dashboardData.stats.totalAmountReceived)}</h2>
              </div>
            </div>
          </div>
          <div className="col-md-3 stretch-card grid-margin">
            <div className="card bg-gradient-success card-img-holder text-white">
              <div className="card-body">
                <h4 className="font-weight-normal mb-2">YTD New Members</h4>
                <h2 className="mb-4 text-white">{dashboardData.stats.newMembersThisYear}</h2>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 grid-margin stretch-card">
            <div className="card">
              <div className="card-body">
                <div className="d-flex align-items-center justify-content-between card-header">
                  <h4 className="card-title float-start">New Member Registrations</h4>
                  <div>
                    <span className="badge badge-primary">{new Date().getFullYear()}</span>
                  </div>
                </div>
                <ReactApexChart
                  options={state.options}
                  series={state.series}
                  type="bar"
                  height={350}
                />
              </div>
            </div>
          </div>
          <div className="col-md-6 grid-margin stretch-card">
            <div className="card stretch-card">
              <div className="card-body">
                <div className="d-flex align-items-center justify-content-between card-header">
                  <h4 className="card-title">Recent transactions</h4>
                  <button className="btn" onClick={() => navigate('/transaction-report')}><img src={`${REACT_APP_BRANDURL}theme/assets/images/icon/view-icon.svg`} alt="view" /> View all</button>
                </div>
                <div className="table-responsive">
                  <table className="table cus-table transaction-table">
                    <thead className='table-dark'>
                      <tr>
                        <th> Date </th>
                        <th> Amount </th>
                        <th> Payee Name </th>
                        <th> Method </th>
                        <th> Category </th>
                        <th> Receipt </th>
                      </tr>
                    </thead>
                    <tbody>
                      {dashboardData.recentTransactions.map((transaction, index) => (
                        <tr key={index}>
                          <td>{formatDate(transaction.date)}</td>
                          <td>{formatCurrency(transaction.amount)}</td>
                          <td>{transaction.payment_name || 'N/A'}</td>
                          <td>{transaction.method || 'N/A'}</td>
                          <td>{transaction.category || 'Subscription'}</td>
                          <td>
                            {transaction.reciept_url ? (
                              <button
                                className="btn btn-sm btn-outline-primary py-1 px-2"
                                onClick={() => window.open(process.env.REACT_APP_APIBRANDURL + transaction.reciept_url, '_blank')}
                                title="Download Receipt"
                              >
                                <i className="mdi mdi-download"></i> Download
                              </button>
                            ) : (
                              <span className="text-muted text-small">N/A</span>
                            )}
                          </td>
                        </tr>
                      ))}
                      {dashboardData.recentTransactions.length === 0 && (
                        <tr>
                          <td colSpan="6" className="text-center">No transactions found</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>

      </Wrapper>
    </>
  )
}
